import { REHYDRATE } from 'redux-persist';
import { call, put, select, take } from 'redux-saga/effects';

import { EMAIL_TEMPLATE_TYPE_BY_TOKEN } from '../../../constants/createSendEmail';
import { IEmailTemplate } from '../../../types/templates';
import { selectEmailTemplates } from '../../selectors/templates';
import {
  ADD_CS_ITEM,
  APPLY_CS_CUSTOM_KIT,
  REMOVE_CS_ITEM,
  RESET_CS_CUSTOM_KIT,
  SET_CS_GIFT_BUDGET,
  SET_CS_GIFT_CHOICE_MODE,
  SET_CS_KITS,
  TOGGLE_CS_KIT,
} from '../actions/contents';
import { resetCsEmail } from '../actions/email';
import { SET_CS_ADDRESS_MODE, SET_CS_CLAIM_LINK_MODE, SET_CS_MULTI_KIT_ADDRESS_MODE } from '../actions/recipients';
import { selectCsEmailTemplateId, selectCsRequiredEmailToken } from '../selectors/email';

export const EMAIL_SCENARIO_ACTIONS = [
  TOGGLE_CS_KIT,
  SET_CS_KITS,
  SET_CS_GIFT_CHOICE_MODE,
  SET_CS_GIFT_BUDGET,
  APPLY_CS_CUSTOM_KIT,
  ADD_CS_ITEM,
  REMOVE_CS_ITEM,
  RESET_CS_CUSTOM_KIT,
  SET_CS_ADDRESS_MODE,
  SET_CS_CLAIM_LINK_MODE,
  SET_CS_MULTI_KIT_ADDRESS_MODE,
  REHYDRATE,
];

export const isEmailTemplateCompatible = (
  template: IEmailTemplate | undefined,
  requiredToken: string | null,
): boolean => {
  if (!template) {
    return true;
  }

  if (requiredToken === null) {
    return false;
  }

  return template.type === EMAIL_TEMPLATE_TYPE_BY_TOKEN[requiredToken];
};

export function* resetIncompatibleEmailWorker(): Generator<any, any, any> {
  const templateId: string | null = yield select(selectCsEmailTemplateId);

  if (templateId === null) {
    return;
  }

  const templates: IEmailTemplate[] | undefined = yield select(selectEmailTemplates);
  const template = templates?.find((item) => item.item_id === templateId);
  const requiredToken: string | null = yield select(selectCsRequiredEmailToken);

  if (!isEmailTemplateCompatible(template, requiredToken)) {
    yield put(resetCsEmail());
  }
}

const emailCompatibility = {
  *watchEmailScenarioChanged(): Generator<any, any, any> {
    while (true) {
      yield take(EMAIL_SCENARIO_ACTIONS);
      yield call(resetIncompatibleEmailWorker);
    }
  },
};

export default emailCompatibility;
